const SITE_URL = 'https://bpcard.ru';
const SITE_NAME = 'Комбинат питания «Большая перемена»';
const SITE_IMAGE = 'https://bpcard.ru/images/general_img/15-30.jpg';

const DEFAULT_DESCRIPTION =
  '«Большая Перемена» — безналичная оплата питания в школьных столовых: пополнение счёта ребёнка, контроль списаний с электронной карты на сайте bpcard.ru.';

const PAGE_META = {
  '/': {
    title: 'Комбинат питания «Большая перемена» — безналичная оплата питания в школах',
    description: DEFAULT_DESCRIPTION,
    type: 'website',
  },
  '/payment': {
    title: 'Быстрая оплата — пополнить счёт питания | Большая перемена',
    description:
      'Пополните лицевой счёт ребёнка банковской картой МИР, VISA, MasterCard или через SberPay. Деньги зачисляются на счёт в течение 20 минут.',
    type: 'website',
  },
  '/shops': {
    title: 'Наши магазины | Большая перемена',
    description:
      'Адреса и контакты магазинов «Большой перемены». Сбалансированное питание и продукты для школьников.',
    type: 'website',
  },
  '/pay_info': {
    title: 'Платёж успешно обработан | Большая перемена',
    description:
      'Платёж успешно обработан, деньги зачисляются на счёт в течение 20 минут.',
    type: 'website',
  },
  '/new': {
    title: 'Новости | Большая перемена',
    description: 'Новости комбината питания «Большая перемена».',
    type: 'article',
  },
  '/user': {
    title: 'Личный кабинет | Большая перемена',
    noindex: true,
    type: 'website',
  },
  '/functions': {
    title: 'Функции | Большая перемена',
    noindex: true,
    type: 'website',
  },
};

function getMetaByPath(path) {
  if (path.startsWith('/new/')) return Object.assign({}, PAGE_META['/new']);
  if (path.startsWith('/functions/'))
    return Object.assign({}, PAGE_META['/functions']);
  return PAGE_META[path] || PAGE_META['/'];
}

function upsertTag(selector, tagName, attrs) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement(tagName);
    document.head.appendChild(tag);
  }
  Object.keys(attrs).forEach(key => tag.setAttribute(key, attrs[key]));
}

export function stripHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html || '';
  return div.textContent || '';
}

export function setPageMeta(path, overrides) {
  const meta = Object.assign({}, getMetaByPath(path), overrides || {});
  const url = SITE_URL + '/' + String(path || '/').replace(/^\/+/, '');

  document.title = meta.title;

  upsertTag('meta[name="description"]', 'meta', {
    name: 'description',
    content: meta.description || '',
  });
  upsertTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: url });
  upsertTag('meta[property="og:title"]', 'meta', {
    property: 'og:title',
    content: meta.title,
  });
  upsertTag('meta[property="og:description"]', 'meta', {
    property: 'og:description',
    content: meta.description || '',
  });
  upsertTag('meta[property="og:url"]', 'meta', {
    property: 'og:url',
    content: url,
  });
  upsertTag('meta[property="og:type"]', 'meta', {
    property: 'og:type',
    content: meta.type || 'website',
  });
  upsertTag('meta[property="og:site_name"]', 'meta', {
    property: 'og:site_name',
    content: SITE_NAME,
  });
  upsertTag('meta[property="og:image"]', 'meta', {
    property: 'og:image',
    content: SITE_IMAGE,
  });

  if (meta.noindex) {
    upsertTag('meta[name="robots"]', 'meta', {
      name: 'robots',
      content: 'noindex, nofollow',
    });
  } else {
    const robots = document.head.querySelector('meta[name="robots"]');
    if (robots) robots.parentNode.removeChild(robots);
  }
}